<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="isCreate"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="this.$route.params.id"
  />
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import CategoryDataService from '@/services/api/CategoryDataService'

  export default {
    components: { EntityEditForm },
    data () {
      return {
        title: 'Новая категория',
        isCreate: true,
        listRouteName: 'categoriesList',
        dataService: CategoryDataService,
        fields: CategoryDataService.getCrudFields(),
      }
    },
  }
</script>
